import React, { useContext } from "react";
import { StaticContentContext } from "../../Layout";
import Logo from "../Logo";
import "./style.scss";

function Footer() {
  const {staticContent: {main_company, companies, contact}} = useContext(StaticContentContext);
  return (
    <footer className="Footer">
      <Logo idPrefix="footer-logo" className="Footer__logo" size="medium" />
      <div className="Footer__companies">
        <address className="Footer__companyfields Footer__maincompany">
          <div className="Footer__company Footer__company--maininfo">
            {main_company.name && <p className="Footer__name">{main_company.name}</p>}
            {main_company.description.length > 0 && main_company.description.map((paragraph, index) => (
              <p key={paragraph.text + index} className="Footer__description">{paragraph.text}</p>
            ))}
            {main_company.address && <p className="Footer__address">{main_company.address}</p>}
            {(main_company.zipcode || main_company.city) && (
              <div className="Footer__location">
                {main_company.zipcode && <p className="Footer__zipcode">{main_company.zipcode}</p>}
                {main_company.city && <p className="Footer__city">{main_company.city}</p>}
              </div>
            )}
          </div>
          <div className="Footer__company Footer__company--contactinfo">
            {main_company.phone && <p className="Footer__phone">{main_company.phone}</p>}
            {main_company.email && (
              <a
                href={`mailto:${main_company.email}`}
                className="Footer__link Footer__email"
              >
                {main_company.email}            
              </a>
            )}
            {main_company.web && (
              <a
                href={main_company.web.url}
                className="Footer__link Footer__web"
                target={main_company.web.target}
              >
                {main_company.web.title}
              </a>
            )}
          </div>
        </address>
        <div className="Footer__companyfields Footer__subcompanies">
          {companies.length > 0 && companies.map(company => (
            <address key={company.name} className="Footer__company">
              {company.name && <p className="Footer__name">{company.name}</p>}
              {company.phone && <p className="Footer__phone">{company.phone}</p>}
              {company.email && <a href={`mailto:${company.email}`} className="Footer__link Footer__email">{company.email}</a>}
              {company.web && (
                <a
                  href={company.web.url}
                  className="Footer__link Footer__web"
                  target={company.web.target}
                >
                  {company.web.title}
                </a>
              )}
            </address>
          ))}
        </div>
      </div>
      <p className="Footer__contact">{contact}</p>
    </footer>
  );
}

export default Footer;
